import React from 'react';
import { Alert } from 'react-bootstrap';
import { useFlashMessage } from '../contexts/FlashMessageContext';
import { AnimatePresence, motion } from 'framer-motion';

const FlashMessage: React.FC = () => {
  const { message, type, index } = useFlashMessage();

  if (!message) return null;

  const lines = message.split('\n').filter((line) => line.trim() !== '');

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
          className="position-fixed top-0 start-50 translate-middle-x mt-4"
          style={{
            zIndex: 1050,
            maxWidth: '90%',
          }}
        >
          <Alert variant={type || 'info'} dismissible key={index}>
            <strong>
              {lines.map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </strong>
          </Alert>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FlashMessage;
